<template>
  <b-card :header="header" class="import-preview">

    <table class="props-compact-2">
      <tr>
        <th>status</th>
        <td :class="statusClass">
          {{statusStr}}
        </td>
      </tr>
      <tr>
        <th>begin</th>
        <td>{{importObject.stime | getMomentStr}}</td>
      </tr>
      <tr v-if="isEnded">
        <th>end</th>
        <td>{{importObject.ftime | getMomentStr}}</td>
      </tr>
      <tr v-if="isEnded">
        <th>duration</th>
        <td>{{importObject.durationMSec}} msec</td>
      </tr>
    </table>

    <contest-imports-table
      v-if="contestImports !== null"
      :contestImports="contestImports"
      class="mt-3"
    />

  </b-card>
</template>

<script>
import ContestImportsTable from './ContestImportsTable.vue';

export default {
  name: 'ContestGroupImportPreview',

  components: {
    ContestImportsTable,
  },

  props: {
    importObject: {
      type: Object,
      required: true,
    },
  },

  computed: {
    /** @returns {?string} */
    header() {
      const idStr = this.importObject.id.toString()
      return 'Import ' + idStr;
    },

    /** @returns {boolean} */
    isActive() {
      return !this.isEnded;
    },

    /** @returns {boolean} */
    isEnded() {
      const imp = this.importObject;
      return ('ftime' in imp) && (imp.ftime > 0);
    },

    /** @returns {string} */
    statusStr() {
      return this.isEnded ? 'ended' : 'started';
    },

    /** @returns {Object} */
    statusClass() {
      return {
        activeImport: this.isActive,
      };
    },

    /** @returns {Object[] | null} */
    contestImports() {
      const imp = this.importObject;
      if(!('contestImports' in imp)) {
        return null;
      }

      const contestImports = imp.contestImports;
      if(contestImports === undefined || contestImports === null) {
        return null;
      }

      if(contestImports.length === 0) {
        return null;
      }

      return contestImports;
    }
  },
};
</script>

<style scoped>
.import-preview .card-body,
.import-preview .card-header {
  padding: 9px;
}

.activeImport {
  color: var(--green);
}
</style>
